<div class="container mt-4">
  <div class="d-flex align-items-center mb-2 position-relative" id="liveVideoPlayerWrapper">
    <video
      id="liveVideoPlayer"
      #liveVideoPlayer
      [srcObject]="stream"
      muted
      playsinline
      class="mx-auto"
      style="max-width: 100%; height: 0; background-color: black"
    ></video>

    <!-- Camera Toggle Button - Positioned at bottom right of video -->
    <div
      *ngIf="isLiveStreaming && !isRecording && isMobileDevice && !videoRecorded"
      class="position-absolute camera-toggle-wrapper"
      style="bottom: 10px; right: 10px; z-index: 10"
    >
      <button
        class="btn btn-dark btn-sm rounded-circle camera-toggle-btn"
        (click)="toggleCamera()"
        title="Switch Camera"
        style="
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid rgba(255, 255, 255, 0.3);
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
        "
      >
        <ion-icon name="camera-reverse" style="font-size: 24px; color: white"></ion-icon>
      </button>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center">
    <button
      *ngIf="!isLiveStreaming && !this.videoURL"
      class="btn btn-secondary mr-2 d-flex align-items-center"
      (click)="startLiveStream()"
    >
      <ion-icon name="camera" class="mr-1"></ion-icon> Start Live Preview
    </button>
  </div>

  <!-- Live Streaming and Recording Controls -->
  <div *ngIf="!videoRecorded" class="recording-controls text-center">
    <!-- Stop Live Stream Button -->
    <button
      *ngIf="isLiveStreaming && !isRecording"
      class="btn btn-danger mr-2"
      (click)="stopLiveStream()"
    >
      <ion-icon name="close"></ion-icon> Stop Preview
    </button>

    <!-- Recording Timer -->
    <div *ngIf="isRecording" class="recording-timer mb-3">
      <span class="badge badge-danger">
        <ion-icon name="time"></ion-icon>
        {{ formatTime(recordingTime) }}
      </span>
    </div>

    <!-- Start Recording Button -->
    <button
      *ngIf="isLiveStreaming && !isRecording"
      class="btn btn-primary mr-2"
      (click)="startRecording()"
    >
      <ion-icon name="videocam"></ion-icon> Start Recording
    </button>

    <!-- Recording Control Buttons -->
    <ng-container *ngIf="isRecording">
      <div class="d-flex justify-content-center">
        <button *ngIf="!isPaused" class="btn btn-warning mr-2" (click)="pauseRecording()">
          <ion-icon name="pause"></ion-icon> Pause
        </button>

        <button *ngIf="isPaused" class="btn btn-success mr-2" (click)="resumeRecording()">
          <ion-icon name="play"></ion-icon> Resume
        </button>

        <button class="btn btn-danger" (click)="stopRecording()">
          <ion-icon name="stop"></ion-icon> Stop
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Recorded Video Player -->
  <div *ngIf="videoRecorded" class="recorded-video-player mt-3">
    <div class="card">
      <div class="card-body">
        <!-- Video Player -->
        <video
          #videoPlayer
          [src]="videoURL"
          controls
          class="mb-3 mx-auto"
          style="max-width: 100%; max-height: 500px"
        >
          Your browser does not support the video element.
        </video>

        <!-- Action Buttons -->
        <div class="video-actions d-flex justify-content-center">
          <button class="btn btn-danger mr-2" (click)="deleteRecording()">
            <ion-icon name="trash"></ion-icon> Delete
          </button>

          <button class="btn btn-success" (click)="uploadRecording()" [disabled]="isUploading">
            <ion-icon name="cloud-upload"></ion-icon> Upload
          </button>
        </div>

        <div class="card mt-2" style="padding: 1rem" *ngIf="uploadPercentage">
          <div class="progress">
            <div
              class="progress-bar bg-warning"
              role="progressbar"
              [style.width.%]="uploadPercentage"
              [attr.aria-valuenow]="uploadPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ uploadPercentage }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <span
    class="my-2 d-flex justify-content-center"
    *ngIf="!(isRecording || videoRecorded || isLiveStreaming)"
    >OR</span
  >

  <ng-container *ngIf="!(isRecording || videoRecorded || isLiveStreaming)">
    <app-local-file-selector
      [type]="'video'"
      (fileDropped)="onFileReceived($event)"
    ></app-local-file-selector>
  </ng-container>
</div>
